import { BCMSRecord, useGlobalController, DisabledPrompt, BCMSDate } from "bcms-react";
import { Account, CheckingAccount, SavingsAccount, CODAccount, LoanAccount } from "model";

import CustomSelect, { CustomSelectItem } from 'components/custom-ui/CustomSelect';
import DateSelect from 'components/custom-ui/DateSelect';
import { UIRadio } from 'components/custom-ui/UIRadioGroup';
import { CenterContentContainer, ContentHeaderView, FormContainer, FormRowView, PageContainer, PageContentView } from 'components/shared';
import { PrimaryButton } from 'components/ui';
import React from 'react';
import "./styles.css";
/**
 * @function DownloadPage
 * @return {React.Component}
 * @exported true
 * @description The main component for DownloadPage
 */
export default function DownloadPage(props) {
  // Initalize a global controller and set the global controller for required model classes
  const controller = useGlobalController();
  BCMSRecord.globalControllerFor([ Account, CheckingAccount, SavingsAccount, CODAccount, LoanAccount ], controller);

  // Create all account items for the account dropdown
  const accountItems = Account.initAll().reduce((result, account) => {
    const label = account.balanceLabel;
    const balance = account.balanceLabel === "Available Balance" ? account.availableBalance.format() : account.currentBalance.format();

    const balanceLabel = account.type !== "loan" ? `(${ label } ${ balance })` : "";

    return result.concat(
      <CustomSelectItem value={ account.id } key={ `Download_Account_${ account.id }` }>
        { `${ account.number } - ${ account.nickname } ${ balanceLabel }` }
      </CustomSelectItem>
    );
  }, [ <CustomSelectItem value="prompt" key="prompt">-- Select an Account --</CustomSelectItem> ]);

  const startDate = BCMSDate.init().offset([ 0, -2, 0 ]);
  const endDate = BCMSDate.init().offset(-1);

  return (
    <PageContainer className="download-page">
      <PageContentView>
        <CenterContentContainer>
          <ContentHeaderView text="Download"/>
          <FormContainer className="download-form">
            <FormRowView text="Account">

              <CustomSelect value="prompt">
                { accountItems }
              </CustomSelect>

            </FormRowView>
            <FormRowView text="Start Date">
              <DateSelect value={ startDate } enablePast={ true } enableFuture={ false } />
            </FormRowView>
            <FormRowView text="End Date">
              <DateSelect value={ endDate } enablePast={ true } enableFuture={ false } />
            </FormRowView>
            <FormRowView text="Download Format">
              <UIRadio label="Quicken" name="download-format" checked={ true } />
              <UIRadio label="Quickbooks" name="download-format" />
            </FormRowView>
            <FormRowView>
              <DisabledPrompt>
                <PrimaryButton text="Download" />
              </DisabledPrompt>
            </FormRowView>
          </FormContainer>
        </CenterContentContainer>
      </PageContentView>
    </PageContainer>
  )
}
